module.exports = __webpack_public_path__ + "img/invoice-de-male-banner-st.a96122e8.png";